import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "my-no-more" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_VueEternalLoading = _resolveComponent("VueEternalLoading")

  return (_openBlock(), _createBlock("div", null, [
    _renderSlot(_ctx.$slots, "default", { items: _ctx.items }),
    _createVNode(_component_VueEternalLoading, {
      load: _ctx.loadData,
      "is-initial": _ctx.isInitial,
      "onUpdate:is-initial": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isInitial = $event)),
      class: "flex justify-center",
      id: _ctx.id
    }, {
      loading: _withCtx(() => [
        _createVNode(_component_ProgressSpinner, {
          class: "h-8",
          strokeWidth: "5"
        })
      ]),
      "no-more": _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["load", "is-initial", "id"])
  ]))
}